import { MRT_Localization } from "material-react-table";
import i18n from "../i18n";
import el from "./el";
import { MRT_Localization_EN } from "material-react-table/locales/en";
const langMapper = {
  el: el,
  en: MRT_Localization_EN,
};
export default function getTableLang(): MRT_Localization {
  const currentLang = i18n.language;
  return langMapper[currentLang];
}
